import SettingsStarterRouter from './SettingsStarterRouter';

export default SettingsStarterRouter;
